import Vue, { CreateElement } from 'src/vue'
import { Component } from 'vue-property-decorator'
import camelcaseKeys from 'camelcase-keys'

import { Button } from '@src/elements/button/button'
import { Form } from '@src/components/form/form'
import { Input } from '@src/elements/input/input'
import { ContentBox } from '@src/elements/content-box/content-box'

import Club from '@src/data/club'
import { ClubInfoDTO } from '@src/dto/club-dto'
import { snakecaseKeys, track } from '@src/util/functions'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'

import './club-info.sass'

@Component({
  computed: {
    club () {
      return this.$store.state.club
    }
  }
})
export class ClubInfo extends Vue {

  private club: Club

  private apiClientClub: ApiClient = new ApiClient()
  private errors: any = {}

  constructor () {
    super()
    track('/club/club-info')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MY_CLUB')} - ${this.$root.$t('PAGE.CLUB.CLUB_INFO.TAB_NAME')}`
  }

  save () {
    this.apiClientClub.put(API.TRAINERS_API.CLUB, { club: snakecaseKeys(new ClubInfoDTO(this.club)) })
      .then(() => {
        this.errors = {}
        this.$store.dispatch('showToast', { message: this.$t('ACKNOWLEDGEMENT.SUCCESSFUL_CHANGES'), fadeOut: true })
      })
      .catch((error) => this.errors = camelcaseKeys(error.errorData.errors))
  }

  render (h: CreateElement) {
    return <div class='club-info'>
      <ContentBox>
        <Form direction={'column'} slot={'content'}>
          <div>
            <Input label={`${this.$t('PAGE.CLUB.CLUB_INFO.ADDRESS_LINE')}1`} ref='address1' value={this.club.addressLine1}
                   valueChanged={(value) => this.club.addressLine1 = value} class={this.errors.addressLine1 ? 'error' : ''} />
          </div>
          <div>
            <Input label={`${this.$t('PAGE.CLUB.CLUB_INFO.ADDRESS_LINE')}2`} ref='address2' value={this.club.addressLine2}
                   valueChanged={(value) => this.club.addressLine2 = value} class={this.errors.addressLine2 ? 'error' : ''} />
          </div>
          <div>
            <Input label={`${this.$t('PAGE.CLUB.CLUB_INFO.ADDRESS_LINE')}3`} ref='address3' value={this.club.addressLine3}
                   valueChanged={(value) => this.club.addressLine3 = value} class={this.errors.addressLine3 ? 'error' : ''} />
            <Input label={this.$t('PAGE.CLUB.CLUB_INFO.POSTCODE')} ref='postcode' value={this.club.addressPostcode}
                   valueChanged={(value) => this.club.addressPostcode = value}
                   class={this.errors.addressPostcode ? 'error' : ''} />
          </div>
          <div>
            <Input label={this.$t('PAGE.CLUB.CLUB_INFO.CITY')} ref='city' value={this.club.addressTownCity} valueChanged={(value) => this.club.addressTownCity = value}
                   class={this.errors.addressTownCity ? 'error' : ''} />
            <Input label={this.$t('PAGE.CLUB.CLUB_INFO.COUNTRY')} ref='country' value={this.club.addressCountry}
                   valueChanged={(value) => this.club.addressCountry = value}
                   class={this.errors.addressCountry ? 'error' : ''} />
          </div>
        </Form>
        <div slot={'bottom'}>
          <Button type='elevated' class='apply-btn' label={this.$t('APPLY')} click={this.save} />
        </div>
      </ContentBox>
    </div>
  }

  beforeDestroy () {
    this.$store.dispatch('closeToast')
  }
}
